import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';

import { editOrganisation } from '@/domain/organisation/actions/edit-organisation.action';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import {
  selectIsEditingOrganisation,
  selectOrganisationInfos,
} from '@/domain/organisation/organisation.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { OrganisationForm } from '@/ui/pages/app/organisation/components/OrganisationForm';

export function OrganisationSection() {
  const dispatch = useAppDispatch();

  const initialOrganisationState = useAppSelector(selectOrganisationInfos);
  const isEditingOrganisation = useAppSelector(selectIsEditingOrganisation);

  const [organisation, setOrganisation] = useState<Organisation | null>(null);

  useEffect(() => {
    setOrganisation(
      initialOrganisationState ? { ...initialOrganisationState } : null,
    );
  }, [initialOrganisationState]);

  const handleSave = async (data: Organisation) => {
    try {
      const params = { organisation: data };
      await dispatch(editOrganisation(params)).unwrap();
    } catch (error) {
      console.error(error);
    }
  };

  const formButtons = (
    <Stack sx={{ flexDirection: 'row', justifyContent: 'end', mt: 2 }}>
      <FSPrimaryButton disabled={isEditingOrganisation} type="submit">
        {translate('Form.save')}
      </FSPrimaryButton>
    </Stack>
  );

  if (!initialOrganisationState || !organisation) {
    return null;
  }

  return (
    <OrganisationForm
      organisation={organisation}
      onSubmit={handleSave}
      buttons={formButtons}
    />
  );
}
